import React, { memo } from "react";
import { useHomePage } from "./index.hooks";
import { AppButton } from "components";
import { Box, Container, Typography } from "@mui/material";
import bgMobileImage from "assets/sfondo_mobile.png";
import bgDesktopImage from "assets/sfondo_desktop.jpg";
import logoFS_white from "assets/logoFS_white.svg";
import logoFS_color from "assets/fs_logo_colori.svg";
import logoPP from "assets/logo_with_subtitle.png";
import { ReactComponent as RightArrow } from "assets/arrow.svg";

type HomePageProps = {};

export const HomePage = memo(({}: HomePageProps) => {
  const { isMobile, isTooNarrow, onButtonPressed } = useHomePage();

  return (
    <Box
      sx={{
        margin: 0,
        backgroundImage: {
          xs: `url(${bgMobileImage})`,
          md: `url(${bgDesktopImage})`,
        },
        backgroundSize: {
          xs: "cover",
          md: "auto 100%",
        },
        backgroundColor: {
          xs: "#FFF",
          md: "#0E4D43",
        },
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={isMobile ? logoFS_color : logoFS_white}
        alt="FS"
        sx={{
          position: "absolute",
          top: {
            xs: 30,
            md: 0,
          },
          right: {
            xs: 15,
            md: 0,
          },
          boxSizing: "content-box",
          height: { xs: 50, md: 55 },
          width: "auto",
          backgroundColor: {
            xs: "transparent",
            md: "#0E4D43",
          },
          padding: {
            md: "2.6vh",
          },
        }}
      />
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Box
          component="img"
          src={logoPP}
          alt="Puzzle Project Edizione Grandi Opere"
          sx={{
            position: "absolute",
            top: "25vh",
            height: "auto",
            width: "80vw",
            maxWidth: "440px",
          }}
        />
        <Box
          sx={{
            height: {
              xs: "18%",
              md: "12%",
            },
            backgroundColor: {
              xs: "#53606B",
            },
            position: "absolute",
            bottom: 0,
            left: "50%",
            display: "flex",
            alignItems: {
              xs: "flex-end",
              md: "center",
            },
            justifyContent: "center",
            transform: "translate(-50%,0)",
            width: {
              xs: "100%",
              md: "680px",
            },
          }}
        >
          <Typography
            variant="h6"
            align="center"
            sx={{
              fontSize: {
                xs: isTooNarrow ? 12 : 15,
                md: 23,
              },
              color: "#FFF",
              height: "100%",
              textTransform: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: {
                xs: "0 10px",
              },
            }}
          >
            <span>
              <strong>Divertiti a ricostruire le nostre grandi opere</strong>
              <br />
              <span style={{ padding: "0 40px", display: "inline-block" }}>
                e scopri in che modo contribuiscono alla ripartenza del Paese!
              </span>
            </span>
          </Typography>
        </Box>

        <AppButton
          variant="contained"
          path="/tutorial"
          onClick={onButtonPressed}
          sx={{
            position: "absolute",
            width: {
              xs: "200px",
              md: "238px",
            },
            borderRadius: 40,
            justifyContent: "space-evenly",
            fontSize: {
              xs: 14,
              md: 16,
            },
            fontWeight: "bold",
            height: {
              xs: 56,
              md: 68,
            },
            bottom: "15%",
          }}
          endIcon={<RightArrow />}
        >
          Gioca
        </AppButton>
      </Container>
    </Box>
  );
});
